import React from 'react';

export interface TeamLogoBackgroundProps {
  /** Team logo URL for the background image. When undefined/falsy, nothing is rendered. */
  logoUrl?: string | null;
  /** Optional additional class names. */
  className?: string;
}

/**
 * Shared decorative background layer showing a team logo at reduced opacity.
 * Used in OverUnderPick and PlayerPick to display the team logo behind the jersey/option.
 */
const TeamLogoBackground: React.FC<TeamLogoBackgroundProps> = ({ logoUrl, className = '' }) => {
  if (!logoUrl) return null;

  return (
    <div
      className={`absolute -top-4 md:top-0 -right-12 md:right-0 md:w-40 md:h-40 w-40 h-40 opacity-15 ${className}`.trim()}
      style={{
        backgroundImage: `url(${logoUrl})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    />
  );
};

export default TeamLogoBackground;
